<ng-container *transloco="let t; read: 'user'">
<h2 class="mb-2 mt-0 text-3xl ">
  {{ t('dashboard.portfolio.classPortfolio.viewingEvidenceFor') }} <b>{{ searchValues?.classroomName }}</b>
</h2>
<h2 class="mb-2 mt-0 text-2xl">
  {{ t('dashboard.portfolio.ratingPeriodLabel') }} <b>{{ searchValues?.ratingPeriodName }}</b>
</h2>
<div class="flex justify-end items-center mr-4 mb-4">
  <a class="text-sm cursor-pointer" (click)="navigateToClassList()">
    {{ t('dashboard.portfolio.classPortfolio.goToClassList') }}
    <i class="uil uil-angle-right-b text-base"></i>
  </a>
</div>
@if (classPortfolio.length) {
  <drdp-container>
    <h2 class="mt-1 mb-3 text-xl font-bold">{{ t('dashboard.portfolio.classPortfolio.evidenceTotals') }}</h2>
    @for (domain of classPortfolio; track domain) {
      <div class="mb-2">
        <div class="md:flex justify-between mt-4">
          <div class="font-semibold text-xl flex items-center gap-3">
            <!-- Domain code/name are server-supplied. -->
            <img class="h-5" src="assets/images/domains/{{domain.iconName}}" [alt]="domain.domainCode">
            {{ domain.domainCode }}
            <i class="uil uil-minus text-2xl -mx-3"></i>
            {{ domain.domainName }}
          </div>
          <div class="flex justify-end items-center text-xl cursor-pointer" (click)="changeDomainShow(domain.domainCode)">
            <b>{{ domain.evidenceCount === 1 ? t('dashboard.portfolio.classPortfolio.evidenceItemCount', { count: domain.evidenceCount }) : t('dashboard.portfolio.classPortfolio.evidenceItemCountPlural', { count: domain.evidenceCount }) }}</b>
        <i class="text-2xl ml-2" [ngClass]="{'uil uil-angle-down': !showDomain || selectedDomain !== domain.domainCode,
            'uil uil-angle-right': showDomain && selectedDomain === domain.domainCode}"></i>
          </div>
        </div>
        @if (showDomain && selectedDomain === domain.domainCode) {
          <div>
            @if (domain.students.length) {
              <div class="pl-4">
                <drdp-student-evidence [students]="domain.students"
                (student)="handleReviewEvidence($event)"></drdp-student-evidence>
              </div>
            }
            <div class="pl-4" [class.mt-6]="!domain.evidenceCount">
              @for (measure of domain.measures; track measure) {
                <div>
                  <div class="md:flex justify-between py-3 border-t border-black">
                    <div class="flex items-center gap-3">
                      <!-- Measure code/name are server-supplied. -->
                      {{ measure.measureCode }} - {{ measure.measureName }}
                    </div>
                    <div class="flex justify-self-end items-center cursor-pointer" (click)="changeMeasureShow(measure.measureCode)">
                      <b>{{ measure.evidenceCount === 1 ? t('dashboard.portfolio.classPortfolio.evidenceItemCount', { count: measure.evidenceCount }) : t('dashboard.portfolio.classPortfolio.evidenceItemCountPlural', { count: measure.evidenceCount }) }}</b>
              <i class="text-2xl" [ngClass]="{'uil uil-angle-down': !showMeasure || selectedMeasure !== measure.measureCode,
                  'uil uil-angle-right': showMeasure && selectedMeasure === measure.measureCode}"></i>
                    </div>
                  </div>
                  @if (showMeasure && selectedMeasure === measure.measureCode) {
                    <div class="pl-4">
                      <drdp-student-evidence [students]="measure.students"
                      (student)="handleReviewEvidence($event)"></drdp-student-evidence>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </drdp-container>
} @else {
  <drdp-container>{{ t('dashboard.portfolio.classPortfolio.empty') }}</drdp-container>
}
</ng-container>
